module.exports = __webpack_public_path__ + "img/ico_btc.8bd13347.png";